import moment from "moment"
import { FC, useEffect, useState } from "react"
import {XIcons} from "../../app/libs/x-ui-core/components"

const FloatMessage: FC = () => {

  const [isFMVisible, setIsFMVisible] = useState(false)
  const [isFMShown, setIsFMShown] = useState(false)

  const openFloatMessage = () => {
    setIsFMShown(true)
    setTimeout(() => {
      setIsFMVisible(true)
    }, 100)
  }

  const closeFloatMessage = () => {
    setIsFMVisible(false)
    setTimeout(() => {
      setIsFMShown(false)
    }, 400)
  }

  useEffect(() => {
    setTimeout(() => {
      const accooks = localStorage.getItem("accepting_cooks")
      if (accooks == null) {
        openFloatMessage()
      }
    }, 1500)
  }, [])

  return (
    <>
      <div className="float_message" style={{
        opacity: isFMVisible ? "1" : "0",
        display: isFMShown ? "flex" : "none"
      }}>
        <div>На сайте используются cookies и Яндекс. Метрика. Продолжая использовать сайт, вы принимаете <a href="https://topgun.plus/uploads/%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D1%81%D0%BA%D0%BE%D0%B5_%D1%81%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5_TOPGUN_Plus.docx" target="_blank">условия</a></div>
        <div>
          <button onClick={() => {
            localStorage.setItem("accepting_cooks", "1")
            closeFloatMessage()
          }}>Принимаю</button>
          <button onClick={() => closeFloatMessage()}><XIcons name="s times" /></button>
        </div>
      </div>
    </>
  )
}

export default FloatMessage